module.exports = __webpack_public_path__ + "static/media/assessmentConfigPage.d41d8cd9.scss";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Assessmentconfig/assessmentConfigPage.scss
// module id = 1973
// module chunks = 0